module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "y7yu20xn",
    dataset: process.env.GATSBY_SANITY_DATASET || "master",
  },
};
